import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getStoreLocationQueryOptions } from '#client/utils/queryOptions';

const StoreLocation = ({ locationId }) => {
    const fetchStore = async () => {
        if (!locationId) return null;
        const res = await axios.get(`${import.meta.env.VITE_API_URL}/api/store-locations?id=${locationId}`);
        if (!res.data?.success || !res.data?.data?.location) {
            return locationId; // Fallback to showing locationId if not found
        }
        return res.data.data.location;
    };

    const { data } = useQuery({
        ...getStoreLocationQueryOptions(locationId),
        queryFn: fetchStore,
    });

    if (data?.name) return <span>{data.name}</span>;
    return <span>{locationId}</span>;
};

export default StoreLocation;
